import { Pagination } from '@unbounded/unbounded-components'
import React from 'react'
import { OrganizationsListItemFragment } from '~api/fragments/OrganizationsListItem.generated'
import { StyledListing, useListingTilesLimit } from '~components/Listing'
// TODO: move organizations list to shared dir?
import OrganizationsList from '~routes/Organizations/OrganizationsListPage/OrganizationsList'

import * as Styled from './OrganizationsList.styles'

interface Props {
  items: OrganizationsListItemFragment[]
}

const OrganizationsListContainer = ({ items }: Props) => {
  const { limit, containerRef } = useListingTilesLimit()

  return (
    <Styled.Container>
      <StyledListing.ListingListContainer ref={containerRef}>
        <OrganizationsList items={items} placeholder="Nothing found" />
      </StyledListing.ListingListContainer>

      <StyledListing.ListingPagination>
        <Pagination page={0} total={Math.floor(items.length / limit)} />
      </StyledListing.ListingPagination>
    </Styled.Container>
  )
}

export default OrganizationsListContainer
